import 'angular';
import 'angular-ui-router';
import 'restangular';
import 'ng-infinite-scroll';
import 'vendor/angular-ui/bootstrap';
import 'vendor/text-angular.js';
import 'vendor/text-angular-sanitize.min.js';
import 'ng-rollbar';
import 'ng-mask';
import 'ngreact';

const requireAll = (requireContext) => {
  requireContext.keys().map((item) => requireContext(item));
};

requireAll(require.context('modules/member_portal', true));
requireAll(require.context('modules/shared', true));
requireAll(require.context('modules/filters', true));
requireAll(require.context('@react/entry_points/shared', true));
requireAll(require.context('templates', true, /\.(html|slim)$/));
